import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const EMAIL_CAMPAIGN_CATEGORIES_QUERY_KEY = 'emailCampaignCategories';

export const useTemplateIndustryCategoriesQuery = ({
	industry,
	enabled = Boolean(industry),
	impersonationContext,
}: {
	impersonationContext?: Api.IImpersonationContext;
	industry: Api.Industry;
	enabled?: boolean;
}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: async () => {
			return userSession.webServiceHelper.callAsync<string[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `template/${encodeURIComponent(industry)}/categories`,
				}),
				'GET'
			);
		},
		queryKey: [EMAIL_CAMPAIGN_CATEGORIES_QUERY_KEY, industry, impersonationContext],
	});
};
